"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _types = require("../types");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var FieldInfoDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldInfoDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("className", _flowRuntime["default"].string()), _flowRuntime["default"].property("info", _flowRuntime["default"].ref(FieldInfoDefinition))));

var State = _flowRuntime["default"].type("State", _flowRuntime["default"].exactObject(_flowRuntime["default"].property("show", _flowRuntime["default"]["boolean"]())));

var FieldInfo = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(FieldInfo, _React$Component);

  var _super = (0, _createSuper2["default"])(FieldInfo);

  function FieldInfo() {
    var _this;

    (0, _classCallCheck2["default"])(this, FieldInfo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      show: false
    };

    _this.handleClick = function (e) {
      e.preventDefault();

      _this.setState(function (prevState) {
        return {
          show: !prevState.show
        };
      });
    };

    return _this;
  }

  (0, _createClass2["default"])(FieldInfo, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          info = _this$props.info;
      return info ? /*#__PURE__*/_react["default"].createElement("div", {
        className: className === undefined ? 'row' : "row info info-".concat(className)
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "#info",
        id: info.title,
        onClick: this.handleClick,
        className: "info-question"
      }, info.title), /*#__PURE__*/_react["default"].createElement("div", {
        className: this.state.show ? 'slide-in' : 'slide-out'
      }, /*#__PURE__*/_react["default"].createElement("div", {
        key: info.title,
        className: "info-answer"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: info.text
        }
      }), info.image && /*#__PURE__*/_react["default"].createElement("img", {
        src: info.image,
        alt: "Visa"
      })))) : null;
    }
  }]);
  return FieldInfo;
}(_react["default"].Component);

exports["default"] = FieldInfo;